import SidemenuItem from "./SidemenuItem";
import PropTypes from "prop-types";
import { StyledSidemenu } from "../../styles/StyledSidemenu";
import useCurrentUser from "../../hooks/useCurrentUser";

// Each item is shown to users with its permission (see lib/permissions), in this order
const menuItems = [
	{ name: "Admin panel", path: "/admin-panel", permission: "adminPanel" },
	{ name: "Decisions", path: "/decisions", permission: "viewDecisions" },
	{ name: "People", path: "/people" },
	{ name: "Units", path: "/units", permission: "viewOrganization" },
	// Root works with organizations instead of an organization's units and decisions
	{ name: "Organizations", path: "/organizations", permission: "manageOrganizations" },
	// The work of a unit: for its members and unit admins
	{ name: "Meetings", path: "/meetings", permission: "unitWork" },
	{ name: "Calendar", path: "/calendar", permission: "unitWork" },
	{ name: "Your Library", path: "/people", permission: "unitWork" }, // Temporarily People, Your Library is under construction
];

export const Sidemenu = ({ items }) => {
	const { can } = useCurrentUser();

	const defaultItems = menuItems.filter((item) => !item.permission || can(item.permission));
	const renderedItems = (Array.isArray(items) ? items : defaultItems).map((item, index) => (
		<SidemenuItem key={index} item={item}></SidemenuItem>
	));

	if (renderedItems.length < 1) return <></>;

	return (
		<StyledSidemenu>
			<ul>{renderedItems}</ul>
		</StyledSidemenu>
	);
};

Sidemenu.propTypes = {
	items: PropTypes.array,
};
